/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import DataTableFilter from "../../Common/DataTableFilter";
import { useNavigate } from "react-router-dom";
import { CREATE_WAREHOUSE_URL } from "../../Shared/constant";
import { ClearFormSetFutios } from "../../../redux/actions/adminActions";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import { WebSocketContext } from "../../../App";
import CommonTable from "../../Common/CommonTable";

const Warehouse = (props) => {
    const Navigate = useNavigate();
    const Dispatch = useDispatch();
    const { wareHouseList, device_id, selfInfo } = useSelector((state) => state.adminReducers);
    const { websocket } = useContext(WebSocketContext);
    const [ userSearch, setUserSearch ] = useState("");
    const [ WHType, setWHType ] = useState("");
    const [ userType, setUserType ] = useState("all");
    const [ userLimit, setUserLimit ] = useState(10);
    const [ currentPage, setCurrentPage ] = useState(1);
    const PermissionsAccess = selfInfo?.user?.permissions_access;

    // page change
    const currentFunction = (page) => {
        setCurrentPage(page);
    };
    
    // select user type
    const SelectUserTypeFnct = (e) => {
        setUserType(e.target.value);
        setCurrentPage(1);
    };

    // select warehouse type
    const SelectsetWHType = (e) => {
        setWHType(e.target.value);
    };

    // get all city list
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Warehouse[0]?.Edit || PermissionsAccess?.Warehouse[0]?.View)) {
            let param = { 
                "transmit": "broadcast", 
                "url": "district_list",
                "request" : { 
                    "status" : "", 
                    "limit" : 5000,
                    "page_no" : 1, 
                    "search" : ""
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        };
    }, [ websocket ]);

    // get all state list
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Warehouse[0]?.Edit || PermissionsAccess?.Warehouse[0]?.View)) {
            let param = { 
                "transmit": "broadcast", 
                "url": "state_list",
                "request" : { 
                    "status" : "", 
                    "limit" : 5000,
                    "page_no" : 1, 
                    "search" : ""
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        };
    }, [ websocket ]);

    // get product list
    useEffect(() => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Warehouse[0]?.Edit || PermissionsAccess?.Warehouse[0]?.View)) {
            let param = { 
                "transmit": "broadcast", 
                "url": "region_list",
                "request" : { 
                    "status" : "", 
                    "limit" : 5000,
                    "page_no" : 1, 
                    "search" : ""
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        };
    }, [ websocket ]);

    // api calling
    const APICall = () => {
        if(selfInfo?.user?.user_type === 'super_admin' || (PermissionsAccess?.Warehouse[0]?.Edit || PermissionsAccess?.Warehouse[0]?.View)) {
            let param = { 
                "transmit": "broadcast", 
                "url": "warehouse_list",
                "request" : { 
                    "status" : userType === "active" ? true : userType === "inactive" ? false : "", 
                    "limit" : userLimit,
                    "page_no" : currentPage, 
                    "wh_type" : WHType,
                    "search" : userSearch.trim()
                },
                "DeviceId" : device_id
            };
            wsSend_request(websocket, param);
        };
    };
    
    // get product list
    useEffect(() => {
       APICall();
    }, [ websocket, userSearch, userType, currentPage, userLimit, WHType ]);

    // create applications
    const cmnFnct = () => {
        Navigate(CREATE_WAREHOUSE_URL);
    };

    useEffect(() => {
        Dispatch(ClearFormSetFutios({
            url:"",
            action:false
        }));
    }, []);

    // TABLE COLUMNS ARRAY
    const TableColumns = [
        { key: 'warehouse_code', label: 'Code', type: "label", sort: "", isCollapsable: false },
        { key: 'warehouse_name', label: 'Name', type: "label", sort: "", isCollapsable: false },
        { key: 'erp_id', label: 'ERP ID', type: "label", sort: "", isCollapsable: false },
        { key: 'warehouse_type', label: 'Category', type: "warehouse_type_category_custom", sort: "", isCollapsable: false },
        { key: 'pin_code_id', label: 'PIN code', type: "label_get_from_list", filterFrom: { list: "pin_code", label: "pin_code" }, sort: "", isCollapsable: false },
        { key: 'pin_code_id', label: 'City', type: "city_label_get_from_warehouse", filterFrom: { list: "pin_code", label: "pin_code" }, sort: "", isCollapsable: false },
        { key: 'pin_code_id', label: 'State', type: "state_label_get_from_warehouse", filterFrom: { list: "pin_code", label: "pin_code" }, sort: "", isCollapsable: false },
        { key: 'is_active', label: 'Status', type: "status_active", sort: "", isCollapsable: false },
    ];

    return(<section className="Main_section Main_section_warehouse">
        <DataTableFilter 
            filterType={"Warehouse"}
            searchType={"Warehouse Name"}
            userSearch={userSearch}
            setUserSearch={setUserSearch}
            WHType={WHType}
            setWHType={setWHType}
            SelectsetWHType={SelectsetWHType}
            userType={userType} 
            setUserType={setUserType}
            userLimit={userLimit} 
            setUserLimit={setUserLimit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            SelectUserTypeFnct={SelectUserTypeFnct}
            buttonvisible={(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.Warehouse[0]?.Edit) ? true : false}
            ButtonSet={{
                buttontitle: "Create Warehouse",
                function: cmnFnct
            }}
            searchdisable={true}
            ActiveInactiveFilter={true}
        />
        {/* COMMON TABLE */}
        <CommonTable 
            isTableAllow={true}
            style={{
                height: parseInt(wareHouseList?.pagination?.total_records) === wareHouseList?.list?.length ? "calc(100vh - 140px)" : parseInt(wareHouseList?.pagination?.total_records) > 10 ? "calc(100vh - 175px)" : "calc(100vh - 140px)"
            }}
            srNumber={{
                clickable: false,
                events: ""
            }}
            isCollapsable={false}
            tabName={""} // TAB URL
            PaginationCurrentPage={currentPage} // TAB CURRENT PAGE
            PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
            TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
            OrderList={wareHouseList} // CATEGORY LIST
            Pagination={wareHouseList?.pagination} // CURRENT TAB PAGINATION
            EditAccess={(selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.Warehouse[0]?.Edit)} // EDITABLE ACCESS STATE
            isActionColumnAvailable={{
                isShow: (selfInfo?.user?.user_type === 'super_admin' || PermissionsAccess?.Warehouse[0]?.Edit),
                label: "edit",
                naviagte: `/edit-warehouse/`
            }}
            isActionTwoColumnAvailable={{
                isShow: false,
                url: "",
            }}
            isOdiFilterRowColorsAllow={false}
        />
    </section>)
}

export default Warehouse;